import { createAsyncThunk } from '@reduxjs/toolkit';

import { fetchCoupon } from '../couponSlice';
import { fetchPlans } from '../plansSlice';
import { fetchProfile } from '../userSlice';
import { type RootState } from '..';

import { completeInitialization } from '../initSlice';
import { switchToSuccessStep } from '../stepsSlice';
import { isLoggedIn, redirectToExternalAuth } from '@/utils/auth';
import { sendPermTokenRequest } from '@/utils/api/login';
import { getParsedParams } from '@/utils/consts/params';

export const fetchAPIData = createAsyncThunk<void, void, { state: RootState }>(
  'fetchAPIData',
  (arg, { dispatch, getState }) => {
    const params = getParsedParams();

    if (!isLoggedIn() && !params.PERMANENT_TOKEN) {
      redirectToExternalAuth();
    } else {
      void Promise.resolve()
        .then(() =>
          params.PERMANENT_TOKEN
            ? sendPermTokenRequest(params.PERMANENT_TOKEN).catch(() => redirectToExternalAuth())
            : null,
        )
        .then(() => Promise.all([dispatch(fetchPlans()), dispatch(fetchProfile()), dispatch(fetchCoupon())]))
        .then(() => {
          if (getState().user.profile?.subscription?.hasActiveSubscription) {
            dispatch(switchToSuccessStep());
          }
        })
        .then(() => dispatch(completeInitialization()));
    }
  },
);
